import { STORE_THIRDPARTY_INFO } from "actions"

export const initialState = {
  thirdpartyAgreeBasicDcm: "0",
  thirdpartyAgreeBasicDpt: "0",
  thirdpartyAgreeBasicCorp: "0",
  thirdpartyAgreeBizDcm: "0",
  thirdpartyAgreeBizDpt: "0",
  thirdpartyAgreeBizCorp: "0",
  thirdpartyAgreeUserDcm: "0",
  thirdpartyAgreeUserDpt: "0",
  thirdpartyAgreeUserCorp: "0",
  thirdpartyAgreeLocationDcm: "0",
  thirdpartyAgreeLocationDpt: "0",
  thirdpartyAgreeLocationCorp: "0",
  thirdpartyAgreeHealthDcm: "0",
  thirdpartyAgreeHealthDpt: "0",
  thirdpartyAgreeHealthCorp: "0",
  thirdpartyAgreeOtherDcm: "0",
  thirdpartyAgreeOtherDpt: "0",
  thirdpartyAgreeOtherCorp: "0",
}

export const thirdPartyInfo = (state = initialState, action) => {
  switch (action.type) {
    case STORE_THIRDPARTY_INFO:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default thirdPartyInfo
